import React from "react";
import { useSelector } from "react-redux";
import LoggedOut from "./LoggedOut";

import LoggedIn from "./LoggedIn";
import useChangeOpenToWork from "../../Hooks/Profile/useChangeOpenToWork";
import notificationIconWithActive from "../../Assets/notificationIconWithdot.svg";
import notificationIconWithoutActive from "../../Assets/notificationIconWithoutdot.svg";
import zepcruitLogo from "../../Assets/logo.png";
import { Link, useNavigate } from "react-router-dom";

const Header = React.forwardRef(({}, ref) => {
  const [loading, error, openToWorkChanger] = useChangeOpenToWork();
  const isUserAuthenticated = useSelector(
    (store) => store?.authStates?.isUserAuthenticated
  );
  const userName = useSelector((store) => store?.user?.email);
  const isOpenToWork = useSelector((store) => store?.user?.open_to_work);
  console.log("open to work", isOpenToWork);
  const Navigate = useNavigate();

  return (
    <div
      ref={ref}
      className="flex items-center justify-between w-full px-3 py-2 lg:px-6 lg:py-4 bg-white-bg-color"
    >
      <div className="flex gap-2 ">
        <Link to={"/dashboard"}>
          <img
            src={zepcruitLogo}
            className="cursor-pointer  lg:hidden"
            alt="zepcruit Icon"
            style={{
              width: `${
                window.screen.availWidth > 376
                  ? 72
                  : window.screen.availWidth / 5
              }px`,
            }}
          />
        </Link>
      </div>
      <div>
        <div data-identity="first">
          <div
            data-identity="open-to-work"
            className="flex items-center justify-center gap-4 "
          >
            <div className="items-center gap-1 p-1 rounded-full ">
              <Link to='mock/plans'>
                <span
                  className={` flex gap-3 items-center text-black border-black border rounded-full px-2 lg:px-4 text-sm lg:text-lg py-1 hover:bg-primary-color-900 hover:text-white hover:border-none`}
                >
                  Buy Mock Test
                </span>
              </Link>
            </div>
            <div className=" flex items-center gap-2 p-1 border-[0.1rem] rounded-full">
              <p className="ml-2 text-xs text-gray-700 ">Job hunting</p>
              <div
                className="flex items-center justify-center gap-2"
                onClick={() => openToWorkChanger(!isOpenToWork)}
              >
                <div
                  className={` cursor-pointer h-[28px] aspect-[2.4/1] flex gap-2 items-center border-[1px] rounded-full p-[0.18rem] ${
                    isOpenToWork
                      ? " justify-end bg-[#06BA6A]"
                      : " justify-start"
                  }`}
                >
                  {isOpenToWork && <p className="text-sm text-white ">Yes</p>}
                  <span
                    className={`h-full aspect-square bg-black rounded-full transition-all ${
                      isOpenToWork ? " bg-white" : " bg-black"
                    }`}
                  ></span>
                  {!isOpenToWork && <p className="text-sm ">No</p>}
                </div>
              </div>
            </div>

            <img
              className="hidden cursor-pointer  lg:block"
              src={notificationIconWithoutActive}
              alt="notificationIconWithActive"
            />
            {isUserAuthenticated === false && <LoggedOut />}
            {isUserAuthenticated === true && <LoggedIn />}
          </div>
        </div>
      </div>
    </div>
  );
});

export default Header;
